import { Vector3 } from '@babylonjs/core/Maths/math.vector'
import { AbstractMesh } from '@babylonjs/core/Meshes/abstractMesh'
import { TransformNode } from '@babylonjs/core/Meshes/transformNode'
import { ComponentType } from '../Frame'
import Part from './Part'

export default class Lens extends Part {
	public hbox: number
	public vbox: number
	public centerLine: number

	public ClipOut: TransformNode

	constructor(parent: TransformNode = null, mirror: boolean = false) {
		super('LENS', parent, mirror)

		this.ClipOut = new TransformNode('CLIP-OUT')
		this.attachmentPoints.set('CLIP-OUT', this.ClipOut)

		this.ClipOut.parent = this
	}

	override get filename(): string {
		if (this.config.components.GROOVE?.color) {
			return `Lenses/Groove/${this.config.components.MODEL.design} ${this.config.components.MODEL.size}`
		} else {
			return `Lenses/${this.config.components.MODEL.design} ${this.config.components.MODEL.size}`
		}
	}

	override async load(file?: File) {
		await super.load(file)
		const mesh = this.container?.meshes.find(x => x.name == 'LENS' || x.name == 'LENS-SURFACE')
		if (mesh) {
			const bounds = mesh.getBoundingInfo()
			const size = bounds.maximum.subtract(bounds.minimum).multiply(new Vector3(1000, 1000, 1000))
			this.hbox = Math.round(size.x)
			this.vbox = size.y
			this.centerLine = (bounds.maximum.y + bounds.minimum.y) / 2
		} else {
			this.hbox = this.vbox = 0
		}
	}

	override getMeshMaterialName(mesh: AbstractMesh): string {
		if (mesh.name == 'LENS' || mesh.name == 'LENS-SURFACE') {
			return this.config.components.LENSES.color
		} else if (mesh.name == 'LENS-EDGE' || mesh.name == 'LENS-NASAL-SLOT' || mesh.name == 'LENS-TEMPORAL-SLOT') {
			return this.config.components.LENS_EDGE.color
		} else if (mesh.name == 'LENS-GROOVE') {
			return this.config.components.GROOVE?.color || this.config.components.LENS_EDGE.color
		} else {
			throw (`Unexpected ${this.name} mesh: (${mesh.name})`)
		}
	}

	// override swap(animated?:boolean){
	//     super.swap(animated)

	//     const mapping: { [P in ComponentType]?: string[]; } = {
	//         "LENSES": ["LENS", "LENS-SURFACE"],
	//         "LENS_EDGE": ["LENS-EDGE", "LENS-NASAL-SLOT", "LENS-TEMPORAL-SLOT"],
	//         "GROOVE": ["LENS-GROOVE"],
	//     }

	//     Object.keys(mapping).forEach(key => {
	//         mapping[key].map(x => this.getComponentMeshes(x)).flat().map(mesh => {
	//             // console.log(mesh.name,">", this.config.components[key]?.color)
	//             mesh.material = this.getScene().getMaterialByName(this.config.components[key]?.color)
	//         })
	//     })    }
}
